module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMCIgaGVpZ2h0PSIxMCIgdmlld0JveD0iMCAwIDEwIDEwIj4KICAgIDxwYXRoIGZpbGw9IiM4ODhCOTQiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTYuMDEgNWwzLjc4LTMuNzhBLjcxMy43MTMgMCAxIDAgOC43OC4yMUw1IDMuOTkgMS4yMi4yMUEuNzEzLjcxMyAwIDEgMCAuMjEgMS4yMkwzLjk5IDUgLjIxIDguNzhhLjcxMy43MTMgMCAxIDAgMS4wMSAxLjAxTDUgNi4wMWwzLjc4IDMuNzhhLjcxMi43MTIgMCAwIDAgMS4wMSAwYy4yOC0uMjc5LjI4LS43MyAwLTEuMDFMNi4wMSA1Ii8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/close.svg
// module id = mq5u
// module chunks = 0 171 185 187 188